import './tracking.css';
import StopNode from './stopNode';
import FlightSegment from './flightSegment';

const timelineData = {
  currentLocation: 'DOH',
  segments: [
    {
      from: 'BER',
      to: 'DOH',
      flightNumber: 'QR-0084 (PAX)',
      pieces: 5,
      departure: '27-Apr-25 22:16',
      arrival: '28-Apr-25 05:01',
    },
    {
      from: 'BER',
      to: 'DOH',
      flightNumber: 'QR-0084 (PAX)',
      pieces: 5,
      departure: '27-Apr-25 22:16',
      arrival: '28-Apr-25 05:01',
    },
    {
      from: 'BER',
      to: 'DOH',
      flightNumber: 'QR-0084 (PAX)',
      pieces: 5,
      departure: '27-Apr-25 22:16',
      arrival: '28-Apr-25 05:01',
    },
  ],
};

export default function LocationIndicator({ data, currentLocation }) {
  console.log('data------------->', data);
  return (
    <div className='location-indicator subtle-scrollbar'>
      {data?.map((segment, idx) => (
        <div
          key={idx}
          className='d-flex align-items-center justify-content-center flex-shrink-0'
        >
          <StopNode
            code={segment.origin}
            isCurrent={currentLocation === segment.origin}
            // icon={'⇆'}
          />
          <FlightSegment segment={segment} />
        </div>
      ))}
      <StopNode
        code={data[data?.length - 1].destination}
        isCurrent={currentLocation === data[data?.length - 1].destination}
      />
    </div>
  );
}
